import {Base} from "@/api/Base"

export class EmployeeListAll extends Base {
    path = "employee/listAll"
}